const CartUpdater = {
  init() {
    // カート関連の要素を初期化
    this.cartContent = document.querySelector('[data-content="cart"]');
    this.cartCountElement = document.getElementById('cart-count');
    this.bindEvents();
    this.updateCartDisplay();
    this.updateCartCount();
    this.initProductPage();
    this.initAddToBagButton();
  },

  bindEvents() {
    // カート更新イベントのリスナーを設定
    document.addEventListener('cartUpdated', () => {
      this.updateCartDisplay();
    });

    // カートに追加フォームのサブミットイベントを処理
    document.querySelectorAll('form[action="/cart/add"]').forEach(form => {
      form.addEventListener('submit', (event) => {
        event.preventDefault();
        this.addToCart(form);
      });
    });

    // カートコンテンツ内のクリックイベントを処理
    this.cartContent.addEventListener('click', (event) => {
      const target = event.target.closest('.nav-cart__remove-item, .nav-cart__quantity-decrease, .nav-cart__quantity-increase, .js-nav-cart__add-to-bag');
      if (!target) return;
    
      if (target.classList.contains('nav-cart__quantity-decrease')) {
        this.updateItemQuantity(target.dataset.id, -1);
      } else if (target.classList.contains('nav-cart__quantity-increase')) {
        this.updateItemQuantity(target.dataset.id, 1);
      } else if (target.classList.contains('nav-cart__remove-item')) {
        this.removeItem(target.dataset.id);
      } else if (target.classList.contains('js-nav-cart__add-to-bag')) {
        this.addRelatedProductToCart(target.dataset.productId, target.dataset.variantId);
      }
    });

    // カートに追加ボタンのクリックイベントを設定
    document.addEventListener('click', (event) => {
      if (event.target.classList.contains('js-nav-cart__add-to-bag')) {
        const productId = event.target.dataset.productId;
        const variantId = event.target.dataset.variantId;
        this.addRelatedProductToCart(productId, variantId);
      }
    });
  },

  initProductPage() {
    // 商品ページの「まとめてカートに追加」ボタンの初期化
    const addBothToBagButton = document.getElementById('add-both-to-bag');
    if (addBothToBagButton) {
      addBothToBagButton.addEventListener('click', () => {
        this.addBothToCart();
      });
    }
  },

  addToCart(form) {
    // フォームデータを使用してカートに商品を追加
    const formData = new FormData(form);
    fetch('/cart/add.js', {
      method: 'POST',
      body: formData
    })
    .then(response => response.json())
    .then(() => {
      this.triggerCartUpdate();
    })
    .catch(error => {
      console.error('カートへの追加中にエラーが発生しました:', error);
    });
  },

  addBothToCart() {
    // 現在の商品と「あわせて購入」商品の両方をカートに追加
    const currentProductForm = document.querySelector('form[action="/cart/add"]');
    const currentProductId = currentProductForm.querySelector('input[name="id"]').value;
    const buyTogetherProductId = document.getElementById('buy-together-product-id').value;

    if (!currentProductId || !buyTogetherProductId) {
      return;
    }

    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        items: [
          {
            id: currentProductId,
            quantity: 1
          },
          {
            id: buyTogetherProductId,
            quantity: 1
          }
        ]
      })
    })
    .then(response => response.json())
    .then(() => {
      this.triggerCartUpdate();
    })
    .catch(error => {
      console.error('両方の商品のカートへの追加中にエラーが発生しました:', error);
    });
  },

  triggerCartUpdate() {
    // カート更新イベントを発火
    document.dispatchEvent(new CustomEvent('cartUpdated'));
    this.updateCartCount();
  },

  async updateCartDisplay() {
    try {
      // カートの最新情報を取得してレンダリング
      const response = await fetch('/cart.js');
      const cart = await response.json();
      await this.renderCart(cart);
      this.updateCartCount();
    } catch (error) {
      console.error('カートの更新中にエラーが発生しました:', error);
    }
  },

  updateCartCount() {
    // カートの商品数を更新
    fetch('/cart.js')
      .then(response => response.json())
      .then(cart => {
        const itemCount = cart.item_count;
        this.cartCountElement.textContent = itemCount;
        
        if (itemCount > 0) {
          this.cartCountElement.classList.add('visible');
        } else {
          this.cartCountElement.classList.remove('visible');
        }
      })
      .catch((error) => {
        console.error('カート数の更新中にエラーが発生しました:', error);
      });
  },

  goToCart() {
    // カートページへ遷移
    window.location.href = '/cart';
  },

  async renderCart(cart) {
    if (cart.item_count === 0) {
      // カートが空の場合の表示
      const emptyCartHtml = `
        <div class="nav-cart__wrapper">
          <div class="nav-cart__header">
            <h2 class="nav-cart__title">カート</h2>
            <button class="nav-cart__close-button js-hover-content-close">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
                <path d="M1.538 20 0 18.462 8.462 10 0 1.538 1.538 0 10 8.462 18.462 0 20 1.538 11.538 10 20 18.462 18.462 20 10 11.538Z"></path>
              </svg>
            </button>
          </div>
          <div class="nav-cart__empty-wrapper">
            <p>カートが空です</p>
            <a href="/collections/all">買い物を続ける</a>
          </div>
        </div>
      `;
      this.cartContent.innerHTML = emptyCartHtml;
      return;
    }

    // カート内の商品アイテムをレンダリング
    const cartItemsHtml = cart.items.map(item => {
      const imageUrl = item.image.replace(/(\.[^.]*)$/, "_140x$1");
      
      return `
        <li class="nav-cart__item" data-id="${item.id}">
          <img src="${imageUrl}" alt="${item.title}" class="nav-cart__item-image">
          <div class="nav-cart__item-details">
            <div class="nav-cart__item-details-upper">
              <div class="nav-cart__item-details-upper-left">
                <h3>${item.product_title}</h3>
                <p>${item.variant_title || ''}</p>
              </div>
              <button class="nav-cart__remove-item" data-id="${item.id}">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
                  <path d="M1.538 20 0 18.462 8.462 10 0 1.538 1.538 0 10 8.462 18.462 0 20 1.538 11.538 10 20 18.462 18.462 20 10 11.538Z"></path>
                </svg>
              </button>
            </div>
            <div class="nav-cart__item-details-lower">
              <p>￥${(item.price / 100).toLocaleString('ja-JP')}</p>
              <div class="nav-cart__quantity-controls">
                <button class="nav-cart__quantity-decrease" data-id="${item.id}">－</button>
                <span class="nav-cart__item-quantity">${item.quantity}</span>
                <button class="nav-cart__quantity-increase" data-id="${item.id}">＋</button>
              </div>
            </div>
          </div>
        </li>
      `;
    }).join('');

    let relatedProductsHtml = '';
    if (cart.items.length > 0) {
      const relatedProducts = await this.getRelatedProducts(cart.items[0].product_id);
      relatedProductsHtml = this.renderRelatedProducts(relatedProducts);
    }

    // カート全体のHTMLを生成
    const cartHtml = `
    <div class="nav-cart__wrapper">
      <div class="nav-cart__header">
        <h2 class="nav-cart__title">カート</h2>
        <button class="nav-cart__close-button js-hover-content-close">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
            <path d="M1.538 20 0 18.462 8.462 10 0 1.538 1.538 0 10 8.462 18.462 0 20 1.538 11.538 10 20 18.462 18.462 20 10 11.538Z"></path>
          </svg>
        </button>
      </div>
      <div class="nav-cart__items-wrapper">
        <div class="nav-cart__scroll-container">
          <ul id="nav-cart__items">${cartItemsHtml}</ul>
          <div class="nav-cart__related-products">
            <h3>関連商品</h3>
            <div class="nav-product__items-wrapper">
            ${relatedProductsHtml}
            </div>
          </div>
        </div>
        <div class="nav-cart__custom-scrollbar">
          <div class="nav-cart__scrollbar-thumb"></div>
        </div>
      </div>
      <div class="nav-cart__footer">
        <div class="nav-cart__total">
          <div class="nav-cart__total-title">合計</div>
          <div class="nav-cart__price-wrapper">
            <div class="nav-cart__total-price">¥${(cart.total_price / 100).toLocaleString('ja-JP')}</div>
            <div class="nav-cart__tax-included">(税込)</div>
          </div>
        </div>
        <button class="nav-cart__checkout-button">カートを見る</button>
      </div>
    </div>
  `;

    this.cartContent.innerHTML = cartHtml;
    this.initCustomScrollbar();

    // チェックアウトボタンにイベントリスナーを追加
    const checkoutButton = this.cartContent.querySelector('.nav-cart__checkout-button');
    if (checkoutButton) {
      checkoutButton.addEventListener('click', () => this.goToCart());
    }

    // 関連商品のカラーチップにイベントリスナーを設定
    const productItems = this.cartContent.querySelectorAll('.nav-product__item');
    productItems.forEach(item => {
      this.attachColorChipListeners(item);
    });
  },

  // カラーチップのHTMLを生成する関数
  generateColorChipsHTML(product, activeVariantId) {
    // カラーコードのマッピング
    const colorMap = {
      'ブラック': '#000000',
      'ネイビー': '#0c2340',
      'グリーン': '#54584e',
      'ペールグリーン': '#6b6d5f',
      'ダークグリーン': '#4e4f4b',
      'カーキ': '#646052',
      'ダークブルー': '#4a505c',
      'ライトグレー': '#c4c0bd',
    };

    // 在庫があるバリアントのみをフィルタリングし、HTMLを生成
    return product.variants
      .filter(variant => variant.available)
      .map(variant => {
        const colorCode = colorMap[variant.title] || '#000000';
        const isActive = variant.id === activeVariantId;
        return `
          <button
            class="nav-cart__color-chip ${isActive ? 'active' : ''}"
            data-variant-id="${variant.id}"
            style="background-color: ${colorCode};"
            title="${variant.title}"
          ></button>
        `;
      })
      .join('');
  },

  // 関連商品をレンダリングする関数
  renderRelatedProducts(products) {
    return products.map(product => {
      // 在庫があるバリアントをフィルタリング
      const availableVariants = product.variants.filter(variant => variant.available);
      if (availableVariants.length === 0) return '';
  
      // 最初の利用可能なバリアントを選択
      const firstAvailableVariant = availableVariants[0];
      
      // バリアントに対応する画像を探す
      let variantImage = product.images.find(image => 
        image.variant_ids.includes(firstAvailableVariant.id)
      );
      
      // バリアントに対応する画像がない場合は商品のデフォルト画像を使用
      let imageUrl = variantImage 
        ? variantImage.src.replace(/(\.[^.]*)$/, "_312x$1")
        : product.featured_image.replace(/(\.[^.]*)$/, "_312x$1");
  
      let price = `¥${Math.floor(parseFloat(firstAvailableVariant.price))}`;
      let variantId = firstAvailableVariant.id;
  
      // バリアント固有のURLを生成
      const productUrl = `/products/${product.handle}?variant=${variantId}`;
  
      // 商品アイテムのHTMLを生成
      return `
      <div class="nav-product__item" data-product-id="${product.id}">
        <div>
          <a href="${productUrl}" class="nav-product__item-link">
          <img src="${imageUrl}" alt="${product.title}" class="nav-cart__related-image">
          </a>
          <a href="${productUrl}" class="nav-product__item-link">
            <h4>${product.title}</h4>
            <p class="nav-cart__product-price">￥${(parseFloat(price.replace(/[^\d.-]/g, '')) || 0).toLocaleString('ja-JP')}</p>
          </a>
          <div class="nav-cart__color-chips">
            ${this.generateColorChipsHTML(product, firstAvailableVariant.id)}
          </div>
        </div>
        <button class="js-nav-cart__add-to-bag" data-product-id="${product.id}" data-variant-id="${variantId}">カートに追加</button>
      </div>
      `;
    }).filter(Boolean).join('');
  },

  // 関連商品のバリアントを更新する関数
  updateRelatedProductVariant(productElement, variantId) {
    const product = this.relatedProducts.find(p => p.id === parseInt(productElement.dataset.productId));
    const variant = product.variants.find(v => v.id === parseInt(variantId));
    
    if (variant) {
      const linkElement = productElement.querySelector('.nav-product__item-link');
      const imageElement = productElement.querySelector('.nav-cart__related-image');
      const priceElement = productElement.querySelector('.nav-cart__product-price');
      const addToBagButton = productElement.querySelector('.js-nav-cart__add-to-bag');
      
      // バリアントに対応する画像を探す
      let variantImage = product.images.find(image => 
        image.variant_ids.includes(variant.id)
      );
      
      // 画像を更新
      if (variantImage) {
        imageElement.src = variantImage.src.replace(/(\.[^.]*)$/, "_312x$1");
      } else {
        // バリアントに対応する画像がない場合は商品のデフォルト画像を使用
        imageElement.src = product.featured_image.replace(/(\.[^.]*)$/, "_312x$1");
      }
      
      // リンクを更新
      linkElement.href = `/products/${product.handle}?variant=${variant.id}`;
      
      // 価格を更新
      priceElement.textContent = `￥${Math.floor(parseFloat(variant.price)).toLocaleString('ja-JP')}`;
      
      // カートに追加ボタンを更新
      addToBagButton.dataset.variantId = variant.id;
      
      // カラーチップを更新
      const colorChipsContainer = productElement.querySelector('.nav-cart__color-chips');
      colorChipsContainer.innerHTML = this.generateColorChipsHTML(product, variant.id);
      
      // 新しいカラーチップにイベントリスナーを再設定
      this.attachColorChipListeners(productElement);
    }
  },

  // カラーチップにイベントリスナーを設定する関数
  attachColorChipListeners(productElement) {
    const colorChips = productElement.querySelectorAll('.nav-cart__color-chip');
    colorChips.forEach(chip => {
      chip.addEventListener('click', (event) => {
        const variantId = event.target.dataset.variantId;
        this.updateRelatedProductVariant(productElement, variantId);
      });
    });
  },

  // 関連商品を取得する非同期関数
  async getRelatedProducts(productId) {
    try {
      const response = await fetch('/products.json?limit=30');
      const data = await response.json();
      // 現在の商品を除外し、在庫のある商品のみをフィルタリング
      const availableProducts = data.products.filter(p => 
        p.id !== parseInt(productId) && 
        p.variants.some(variant => variant.available)
      );
      // ランダムに並び替えて5つ選択
      const shuffled = availableProducts.sort(() => 0.5 - Math.random());
      this.relatedProducts = shuffled.slice(0, 5);
      return this.relatedProducts;
    } catch (error) {
      console.error('関連商品の取得中にエラーが発生しました:', error);
      return [];
    }
  },

  // 関連商品をカートに追加する関数
  addRelatedProductToCart(productId, variantId) {
    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        items: [
          {
            id: variantId,
            quantity: 1
          }
        ]
      })
    })
    .then(response => response.json())
    .then(() => {
      this.triggerCartUpdate();
    })
    .catch(error => {
      console.error('カートへの追加中にエラーが発生しました:', error);
    });
  },

  updateItemQuantity(id, quantityChange) {
    const quantityElement = document.querySelector(`.nav-cart__item[data-id="${id}"] .nav-cart__item-quantity`);
    const currentQuantity = parseInt(quantityElement.textContent);
    const newQuantity = Math.max(1, currentQuantity + quantityChange);
  
    // UIを即座に更新
    quantityElement.textContent = newQuantity;
  
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id, quantity: newQuantity })
    })
    .then(response => response.json())
    .then(cart => {
      this.triggerCartUpdate();
      return cart;
    })
    .catch((error) => {
      console.error('数量更新中にエラーが発生しました:', error);
      // エラーが発生した場合、UIを元に戻す
      quantityElement.textContent = currentQuantity;
      this.updateCartDisplay();
    });
  },

  removeItem(id) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id, quantity: 0 })
    })
    .then(response => response.json())
    .then(() => {
      this.triggerCartUpdate();
    })
    .catch((error) => {
      console.error('商品削除中にエラーが発生しました:', error);
      this.updateCartDisplay();
    });
  },

  initAddToBagButton() {
    const addToBagButton = document.querySelector('.js-add-to-bag-button');
    if (addToBagButton) {
      addToBagButton.addEventListener('click', (event) => {
        event.preventDefault();
        this.addCurrentProductToCart();
      });
    }
  },

  addCurrentProductToCart() {
    // 現在の商品フォームを取得
    const productForm = document.querySelector('form[action="/cart/add"]');
    if (!productForm) {
      return;
    }

    // フォームデータを取得
    const formData = new FormData(productForm);

    // カートに追加
    fetch('/cart/add.js', {
      method: 'POST',
      body: formData
    })
    .then(response => response.json())
    .then(() => {
      this.triggerCartUpdate();
    })
    .catch(error => {
      console.error('現在の商品のカートへの追加中にエラーが発生しました:', error);
    });
  },

  initCustomScrollbar() {
    const wrapper = document.querySelector('.nav-cart__items-wrapper');
    const container = document.querySelector('.nav-cart__scroll-container');
    const scrollbar = document.querySelector('.nav-cart__custom-scrollbar');
    const thumb = document.querySelector('.nav-cart__scrollbar-thumb');
  
    function updateScrollbar() {
      const scrollRange = container.scrollHeight - container.clientHeight;
      const scrollPercentage = container.scrollTop / scrollRange;
      
      const thumbHeight = Math.max(30, (container.clientHeight / container.scrollHeight) * scrollbar.clientHeight);
      const trackHeight = scrollbar.clientHeight - thumbHeight;
      
      thumb.style.height = `${thumbHeight}px`;
      thumb.style.top = `${scrollPercentage * trackHeight}px`;
    }
  
    container.addEventListener('scroll', updateScrollbar);
    
    // ドラッグ操作の実装
    let isDragging = false;
    let startY;
    let startScrollTop;
  
    thumb.addEventListener('mousedown', (e) => {
      isDragging = true;
      startY = e.clientY - thumb.getBoundingClientRect().top;
      startScrollTop = container.scrollTop;
      e.preventDefault(); // テキスト選択を防ぐ
    });
  
    document.addEventListener('mousemove', (e) => {
      if (!isDragging) return;
      const y = e.clientY - scrollbar.getBoundingClientRect().top - startY;
      const scrollRange = container.scrollHeight - container.clientHeight;
      const trackHeight = scrollbar.clientHeight - thumb.clientHeight;
      const scrollPercentage = y / trackHeight;
      container.scrollTop = scrollPercentage * scrollRange;
    });
  
    document.addEventListener('mouseup', () => {
      isDragging = false;
    });
  
    // 初期化時にスクロールバーを更新
    updateScrollbar();
  
    // リサイズ時にスクロールバーを更新
    window.addEventListener('resize', updateScrollbar);
  }
};

document.addEventListener('DOMContentLoaded', () => {
  CartUpdater.init();
});

window.CartUpdater = CartUpdater;